import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ConfirmDialog } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

export const DeleteAssetDialog = ({
  i18n,
  isDisplayed,
  closeDialog,
  onDeleteAsync,
  onDeleteSuccess,
  confirmText,
  errorMessageForUsedAsset,
  warningMsg,
  genericErrorMessage,
  notificationApi,
}) => {
  const [showUIBlocker, setShowUIBlocker] = useState(false);
  const [errorText, setErrorText] = useState('');

  /* istanbul ignore next */
  const handleDelete = useCallback(() => {
    setShowUIBlocker(true);
    onDeleteAsync().then(() => {
      closeDialog();
      onDeleteSuccess();
      notificationApi.showInfo(i18n.getString(_TL_('Your asset was successfully deleted.')));
    }).catch((response = {}) => {
      if (response.errors && response.errors[0] && response.errors[0].Code === 'AssetIsUsed') {
        setErrorText(errorMessageForUsedAsset);
      } else {
        notificationApi.showWarning(genericErrorMessage);
        closeDialog();
      }
    })
      .finally(() => {
        setShowUIBlocker(false);
      });
  }, [closeDialog, errorMessageForUsedAsset, genericErrorMessage, i18n, notificationApi, onDeleteAsync, onDeleteSuccess]);

  /* istanbul ignore next */
  const cancelDelete = useCallback(() => {
    closeDialog();
    setErrorText('');
  }, [closeDialog]);

  return (
    <ConfirmDialog
      isDisplayed={isDisplayed}
      title={confirmText}
      errorText={errorText}
      warningMsg={warningMsg}
      confirmString={i18n.getString(_TL_('OK'))}
      cancelString={i18n.getString(_TL_('Cancel'))}
      onClickConfirm={handleDelete}
      onClickCancel={cancelDelete}
      isUiBlocked={showUIBlocker}
      customStyle={{ zIndex: 1100000, background: 'rgba(255, 255, 255, 0.4)' }}
    />
  );
};

DeleteAssetDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isDisplayed: PropTypes.bool,
  closeDialog: PropTypes.func.isRequired,
  onDeleteAsync: PropTypes.func.isRequired,
  onDeleteSuccess: PropTypes.func.isRequired,
  confirmText: PropTypes.string.isRequired,
  errorMessageForUsedAsset: PropTypes.string.isRequired,
  genericErrorMessage: PropTypes.string.isRequired,
  warningMsg: PropTypes.string,
};

DeleteAssetDialog.defaultProps = {
  isDisplayed: false,
  warningMsg: '',
};
